import React, { useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { getTrainingData } from "../../services/Settings";
import {
  serviceActions,
  useServiceReducer,
} from "../../reducers/serviceReducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSVLink } from "react-csv";
import { useToasts } from "react-toast-notifications";

export default function DataReader() {
  const COLUMNS = [
    "source",
    "text",
    "title",
    "summary",
    "significance",
    "sentiment",
    "aws_sentiment",
    "timestamp",
  ];

  const { addToast } = useToasts();
  const [serviceState, serviceDispatch] = useServiceReducer();
  const [fetchingData, setFetchingData] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const [csvData, setCSVData] = useState(null);
  const [rawData, setRawData] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState([...COLUMNS]);

  async function loadTrainingData() {
    serviceDispatch({ type: serviceActions.LOADING });
    setFetchingData(true);
    setCSVData(null);
    try {
      const result = await getTrainingData();
      if (result && result.Items && result.Items.length) {
        setRawData(result.Items);
        populateCSVData(result.Items);
      } else {
        addToast("There is no tagged training data available", {
          appearance: "warning",
        });
      }
      setFetchingData(false);
      serviceDispatch({ type: serviceActions.SUCCESS });
    } catch (err) {
      console.log("error", err);
      setFetchingData(false);
      serviceDispatch({ type: serviceActions.ERROR, payload: err.message });
    }
  }

  function populateCSVData(list) {
    setFiltering(true);
    const data = [];

    data.push([...selectedColumns]);

    /** 
    data.push([
      "SOURCE",
      "TITLE",
      "TEXT",
      "SUMMARY",
      "SIGNIFICANCE",
      "SENTIMENT",
      "AWS SENTIMENT",
      "TIMESTAMP",
    ]);
    */
    list.forEach((d) => {
      const item = [];
      selectedColumns.forEach((sc) => {
        item.push(d[sc]);
      });
      /** 
      item.push(
        d.source,
        d.title,
        d.text,
        d.summary,
        d.significance,
        d.sentiment,
        d.aws_sentiment,
        d.timestamp
      );
      **/

      console.log(selectedColumns.length, item.length);
      data.push(item);
    });

    setCSVData(data);
    setFiltering(false);
  }
  return (
    <div className="card mb-4">
      <div className="card-header">
        <FontAwesomeIcon icon="table" className="mr-1" />
        Download Tagged Training Data
      </div>
      <div className="card-body">
        <p>
          Use this section to download all the tagged training data.
          <br />
          Please note that '~~' is used as delimiter and '~;' as newline
          separator.
        </p>

        <Card className="pl-2 pt-2 pr-2 mb-5">
          <Card.Title>Step 1</Card.Title>
          <Button
            className="btn btn-primary mb-2"
            disabled={fetchingData}
            onClick={() => loadTrainingData()}
          >
            Retrieve Training Data
          </Button>
        </Card>
        <Card className="pl-2 pt-2 pr-2 mb-5">
          <Card.Title>Step 2 (optional) </Card.Title>
          <Card.Body>
            {COLUMNS.map((c) => {
              return (
                <Form.Check
                  key={`fc-${c}`}
                  inline
                  onChange={(event) => {
                    let s = null;
                    if (!event.target.checked) {
                      const index = selectedColumns.indexOf(c);
                      if (index > -1) {
                        s = [...selectedColumns];
                        s.splice(index, 1);
                      }
                    } else {
                      s = [...selectedColumns];
                      s.push(c);
                    }
                    setSelectedColumns(s);
                  }}
                  label={c}
                  defaultChecked={selectedColumns.includes(c)}
                  type="checkbox"
                />
              );
            })}
          </Card.Body>
          <Button
            className="btn btn-primary mb-2"
            disabled={!csvData || selectedColumns.length === 0}
            onClick={() => populateCSVData(rawData)}
          >
            Filter columns
          </Button>
        </Card>
        <Card className="pl-2 pt-2 pr-2 mb-5">
          <Card.Title>Step 3 </Card.Title>
          {csvData ? (
            <CSVLink
              className="btn btn-success mb-2"
              data={csvData}
              separator="~~"
              enclosingCharacter={""}
              disabled={filtering || !csvData || selectedColumns.length === 0}
            >
              Download Training Data
            </CSVLink>
          ) : (
            <Button className="btn btn-success mb-2" disabled={true}>
              Download Training Data
            </Button>
          )}
        </Card>
      </div>
    </div>
  );
}
